<canvas baseChart
  [data]="chartData"
  [options]="chartOptions"
  [type]="type"
  [width]="width"
  [height]="height"
  >
</canvas>